import React, { useEffect, useRef } from 'react'
import { Provider, useSelector } from 'react-redux'
import Content from './components/content'
import LrSearch from './components/lrSearch'
import Header from './components/header/header'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import LoaderScreen from './components/common/loader'
import GstInvoice from './components/gstInvoice'
import TicketPreview from './components/previews'
import { useAtom } from 'jotai'
import { globalLoaderAtom } from './components/common/jotaiState/globalStateAtoms'
import ViewReport from './components/common/ViewReport'
import ViewReportV2 from './components/common/ViewReportV2'
import MavenReportList from './components/content/ReportList/MavenReportList'
import { I18nProvider } from './i18n/I18nProvider'
import { GetRequest } from './components/common/api'
import { urls } from './components/common/constants'
import { callGlobalData, saveServerTimeDiff } from './globalTime'

function App({ store }) {
  const loader = useSelector((state) => state.common.loader)
  const [loaderJotai] = useAtom(globalLoaderAtom)

  useEffect(() => {
    callGlobalData()
    let lastCheckTime = Date.now()

    const refreshServerTime = () => {
      if (sessionStorage.getItem('token') == null) return
      GetRequest(urls.getServerTime, {}).then((res) => {
        if (res) saveServerTimeDiff(res)
      })
    }

    const updateClock = () => {
      const now = Date.now()
      if (!document.hidden && Math.abs(now - lastCheckTime - 1000) > 20000) {
        refreshServerTime()
      }
      lastCheckTime = now
    }

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        refreshServerTime()
        lastCheckTime = Date.now()
      }
    }

    const interval = setInterval(updateClock, 1000)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      clearInterval(interval)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return (
    <Provider store={store}>
      <I18nProvider>
      <Router>
        <Routes>
          <Route
            exact
            path="/commonlr"
            element={
              <>
                {(loader || loaderJotai) && <LoaderScreen />}
                <LrSearch store={store} />
              </>
            }
          />
          <Route exact path="/GSTInvoice" element={<GstInvoice store={store} />} />
          <Route exact path="/preview" element={<TicketPreview store={store} />} />
          <Route exact path="/view-report" element={<ViewReport />} />
          <Route exact path="/view-reportV2" element={<ViewReportV2 />} />
          <Route exact path="/reports-list" element={<MavenReportList />} />
          <Route
            exact
            path="/"
            element={
              <>
                {(loader || loaderJotai) && <LoaderScreen />}
                <Header store={store} />
                <Content store={store} />
              </>
            }
          />
          <Route
            path="*"
            element={
              <>
                {loader && <LoaderScreen />}
                <Header store={store} />
                <Content store={store} />
              </>
            }
          />
        </Routes>
      </Router>
      </I18nProvider>
    </Provider>
  )
}

export default App
